import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public subject = new BehaviorSubject<any>(false);

  constructor() { }

  show(type = null){
    this.subject.next({ type:type, value:true });
  }

  hide(type = null){
    this.subject.next({ type:type, value:false });
  }
}
